
import Vue from 'vue'
import { IHit } from '../store/state';
import HitComponent from './Hit.vue';
import LoaderComponent from './Loader.vue';

interface HitsData {}
interface HitsMethods {}
interface HitsComputed {
    isSearch: boolean,
    hits: IHit[]
}
interface HitsProps {}

export default Vue.extend<HitsData, HitsMethods, HitsComputed, HitsProps>({
    name: 'HitsComponent',
    computed: {
        isSearch() {
            return this.$store.state.isSearch;
        },
        hits() {
            return this.$store.state.hits;
        }
    },
    components: {
        HitComponent,
        LoaderComponent
    }
})
